/**
 *  @class
 *  @function ToggleBoxes
 */
// if (!customElements.get('toggle-box')) {
//   class ToggleBox extends HTMLElement {

//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       this.button = this.querySelector('.toggle-box--button');

//       this.button.addEventListener('click', () => {
//         this.toggleAttribute('open');
//       });
//     }
//   }
//   customElements.define('toggle-box', ToggleBox);
// }

/**
 * ToggleBoxes — hover on desktop, click on touch
 * Replace the original custom element code with this file.
 */
if (!customElements.get('toggle-box')) {
  class ToggleBox extends HTMLElement {
    constructor() {
      super();

      // bound handlers so we can remove them later
      this._onButtonClickPrevent = this._onButtonClickPrevent.bind(this);
      this._onButtonClickToggle = this._onButtonClickToggle.bind(this);
      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onMouseLeave = this._onMouseLeave.bind(this);
    }

    connectedCallback() {
      // safe query for button
      this.button = this.querySelector('.toggle-box--button');

      // If there's no button, do nothing
      if (!this.button) return;

      // Detect if device supports hover (desktop-like)
      // For browsers that support matchMedia '(hover: hover)'
      const supportsHover = (typeof window !== 'undefined') &&
        window.matchMedia &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (supportsHover) {
        // -- Hover devices: open on hover, disable clicks
        // Ensure any pre-existing 'open' attribute is removed at load
        if (this.hasAttribute('open')) this.removeAttribute('open');

        // Hover handlers on the host element
        this.addEventListener('mouseenter', this._onMouseEnter);
        this.addEventListener('mouseleave', this._onMouseLeave);

        // Prevent the button from toggling via click (stops theme's click handlers)
        this.button.addEventListener('click', this._onButtonClickPrevent, { passive: false });
      } else {
        // -- Touch / coarse pointer: keep click toggle behavior
        this.button.addEventListener('click', this._onButtonClickToggle);
      }
    }

    disconnectedCallback() {
      if (!this.button) return;

      // Remove all handlers we may have added
      this.removeEventListener('mouseenter', this._onMouseEnter);
      this.removeEventListener('mouseleave', this._onMouseLeave);

      this.button.removeEventListener('click', this._onButtonClickPrevent);
      this.button.removeEventListener('click', this._onButtonClickToggle);
    }

    // Handlers
    _onMouseEnter() {
      this.setAttribute('open', '');
    }

    _onMouseLeave() {
      this.removeAttribute('open');
    }

    _onButtonClickPrevent(e) {
      // Stops click from toggling anything (hover-only experience)
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    _onButtonClickToggle() {
      // Default click toggle for touch devices
      this.toggleAttribute('open');
    }
  }

  customElements.define('toggle-box', ToggleBox);
}
